import React from "react";
import { StyledPrimaryHeader } from "../../components/styled";
import SponsorsList from "./sponsorsList";
import { useEventContext } from "../../context/EventProvider";

const SponsorBox = ({ sponsorsWithLevels }) => {
  const { event: { privacyText, privacyLink} } = useEventContext();
  return (
    <div id="sponsors">
      <br />
      <StyledPrimaryHeader>Thank you to our sponsors</StyledPrimaryHeader>
      <SponsorsList sponsorsWithLevels={sponsorsWithLevels} />
      <div className="privacy-policy-wrapper">
        <a href={privacyLink} target="_blank" className="privacy-policy">{privacyText}</a>
      </div>
    </div>
  );
};

export default SponsorBox;
